import script from "./member-fabric-apply.vue?vue&type=script&setup=true&lang=js"
export * from "./member-fabric-apply.vue?vue&type=script&setup=true&lang=js"

import "./member-fabric-apply.vue?vue&type=style&index=0&id=2def0250&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2def0250"]])

export default __exports__